export enum InputTypeEnum {
  TEXT = 1,
  SELECT = 2,
  TEXTAREA = 3,
}
